@if (privateClients.length > 0 && !isLoading) {
  <div class="table-container">
    <table
      mat-table
      [dataSource]="privateClients"
      class="private-clients-table"
    >
      <!-- Nome Cliente Column -->
      <ng-container matColumnDef="nomeCliente">
        <th mat-header-cell *matHeaderCellDef>Cliente</th>
        <td mat-cell *matCellDef="let client">
          {{ client.client_first_name }} {{ client.client_last_name }}
        </td>
      </ng-container>
      <!-- Codice Fiscale Column -->
      <ng-container matColumnDef="codiceFiscale">
        <th mat-header-cell *matHeaderCellDef>Codice Fiscale</th>
        <td mat-cell *matCellDef="let client">{{ client.client_tax_code }}</td>
      </ng-container>
      <!-- Paziente Column -->
      <ng-container matColumnDef="paziente">
        <th mat-header-cell *matHeaderCellDef>Paziente</th>
        <td mat-cell *matCellDef="let client">
          {{ client.patient_first_name }} {{ client.patient_last_name }}
        </td>
      </ng-container>
      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let client">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="modifyClient(client)">
              <mat-icon>edit</mat-icon>
              <span>Modifica</span>
            </button>
            <button mat-menu-item (click)="deleteClient(client)">
              <mat-icon>delete</mat-icon>
              <span>Elimina</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
}

@if (privateClients.length === 0 && !isLoading) {
  <div class="no-clients-container">
    <img src="assets/imgs/undraw/undraw_development.svg" />
    <span>Nessun cliente privato trovato</span>
  </div>
}

@if (isLoading) {
  <div class="loading-container">
    <app-loader [size]="'big'"></app-loader>
  </div>
}
